import IconText from '@ifca-root/react-component/src/components/Typography/IconText';
import OrangeDollarIcon from 'assets/icons/Money/dollar-orange.svg';
import { amtStr } from 'helpers/numFormatter';
import React from 'react';
import { TaxSchemeComponent } from './TaxSchemeComponent';

interface BillFooterProps {
	total?: number;
	discount?: any;
	subtotal?: number;
	tax?: number;
	serviceCharge?: number;
	totalAmount?: number;
	deliveryFee?: number;
	style: React.CSSProperties;
	isConfirmOrder?: boolean;
	highlightText?: boolean;
	currencyCode?: string;
	rounding?: number;
	outletID?: string;
	taxSchemeInfo?: any;
	taxSchemeFooterInfo?: any;
	takeaway?: boolean;
	orderID?: string;
	latestPayment?: any;
	page?:
		| 'bill-item-discount' // done
		| 'bill-settlement' // done
		| 'confirm-order' // done
		| 'bill-listing-detail' // done
		| 'item-transfer-dialog' // done
		| 'kitchen-home'; // no need not the same
}

export const BillFooter = (props: BillFooterProps) => {
	const {
		total,
		discount,
		subtotal,
		serviceCharge,
		tax,
		totalAmount,
		deliveryFee,
		style,
		isConfirmOrder,
		highlightText,
		currencyCode = '',
		rounding,
		outletID,
		taxSchemeInfo,
		taxSchemeFooterInfo,
		takeaway,
		page,
		orderID,
		latestPayment,
	} = props;
	const divChild = (info1: any, info2: any) => {
		return (
			<div
				style={isConfirmOrder ? { paddingBottom: '5px' } : null}
				className={isConfirmOrder ? 'mdDesc' : 'mdDesc bill-ftr-child'}
			>
				<span>{info1}</span>
				<span className="right-info">{info2}</span>
			</div>
		);
	};

	// rounding amount
	let roundAmount = 0;
	latestPayment?.map(x => {
		roundAmount += x?.roundingAmount;
	});

	return (
		<>
			<div
				className={isConfirmOrder ? null : 'bill-footer'}
				style={{ ...style }}
			>
				{divChild(
					'Sub-Total',
					currencyCode +
						Number(subtotal || 0).toLocaleString('en-MY', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}),
				)}

				{deliveryFee !== undefined &&
					deliveryFee !== null &&
					deliveryFee > 0 &&
					divChild(
						'Delivery Fee',
						currencyCode +
							Number(deliveryFee || 0).toLocaleString('en-MY', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							}),
					)}
				{divChild(
					'Discount',
					`(${currencyCode}${Number(discount || 0).toLocaleString('en-MY', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})})`,
				)}
				{page === 'bill-settlement'
					? divChild(
							'Rounding',
							rounding < 0
								? `(${currencyCode} ${Math.abs(rounding).toFixed(2)})`
								: currencyCode + amtStr(rounding),
					  )
					: page === 'bill-listing-detail'
					? divChild(
							'Rounding',
							roundAmount < 0
								? `(${currencyCode} ${Math.abs(roundAmount).toFixed(2)})`
								: currencyCode + amtStr(roundAmount),
					  )
					: ''}
				<div
					className={
						{ highlightText }
							? 'smTitle bill-total'
							: 'smTitle bill-total highlightText'
					}
				>
					{highlightText ? (
						<>
							<div style={{ display: 'flex', flex: 1 }}>
								<div className="flex-space">
									<span>Total</span>
								</div>
								<div className="right-info highlight-text">
									{/* <IconText
										icon={
											<img
												src={OrangeDollarIcon}
												style={{ width: '17px', paddingRight: '2px' }}
											/>
										}
									> */}
									{`${currencyCode}${Number(total || 0).toLocaleString(
										'en-MY',
										{ minimumFractionDigits: 2, maximumFractionDigits: 2 },
									)}`}
									{/* </IconText> */}
								</div>
							</div>
						</>
					) : (
						<>
							<span>Total</span>
							<span className="right-info">
								{currencyCode +
									Number(total || 0).toLocaleString('en-MY', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
							</span>
						</>
					)}
				</div>
				<hr className="line-bill" />
				<div
					className={
						{ highlightText }
							? 'smTitle bill-total'
							: 'smTitle bill-total highlightText'
					}
				>
					{/* {divChild('Service Charge', currencyCode + amtStr(serviceCharge))}
					{divChild('Tax', currencyCode + amtStr(tax))} */}
					<TaxSchemeComponent
						outletID={outletID}
						taxSchemeID={null}
						currencyCode={currencyCode}
						type={'detail'}
						taxSchemeInfo={taxSchemeInfo}
						taxSchemeFooterInfo={taxSchemeFooterInfo}
						takeaway={takeaway}
						orderID={orderID}
					/>
					{/* {deliveryFee !== undefined &&
						deliveryFee !== null &&
						deliveryFee > 0 && (
							<div
								className="m-t-10"
								style={{ display: 'flex', width: '100%' }}
							>
								<span className="mdDesc flex-space">Delivery Fee</span>
								<span className="mdDesc">{`${currencyCode}${amtStr(
									deliveryFee,
								)}`}</span>
							</div>
						)} */}
				</div>
			</div>
		</>
	);
};
